import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom/cjs/react-router-dom.min'

import Port from './port'
import Project from './project'
import Mycv from './mycv'
import About from './about'


function Connector() {
  return (
        <React.Fragment>
            <Router>
                <Switch>
                    <Route exact path='/'>
                        <Port />
                    </Route>
                    <Route exact path='/project'>
                        <Project />
                    </Route>
                    <Route exact path='/about'>
                        <About/>
                    </Route>
                    <Route exact path='/mycv'>
                        <Mycv/>
                    </Route>
                </Switch>
            </Router>
        </React.Fragment>
    )
}

export default Connector